import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Ellipsis, Gift, MapPin, Phone } from 'lucide-react';

function SingleListingSticky({ phone, directionsQuery, onMore, phoneField, directionsField, navigationLocked = false }) {
  const navigate = useNavigate();
  const hasPhone = Boolean(String(phone || '').trim());
  const hasDirections = Boolean(String(directionsQuery || '').trim());
  const directionsHref = hasDirections
    ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(directionsQuery)}`
    : '#';

  return (
    <nav
      id="SingleListingStickyActions"
      aria-label="Single listing quick actions"
      className="fixed bottom-0 left-0 right-0 z-50 grid grid-cols-4 md:hidden"
      style={{
        paddingBottom: 'env(safe-area-inset-bottom, 0px)',
        backgroundColor: 'var(--card)',
      }}
    >
      {hasPhone ? (
        <a
          id="SingleListingStickyActions-Call"
          href={`tel:${phone}`}
          className="flex h-14 flex-col items-center justify-center gap-1 text-black"
          aria-label="Call"
          title={`listing field: ${phoneField}`}
        >
          <Phone size={16} />
          <span className="text-[11px] font-semibold uppercase tracking-[0.06em]">Call</span>
        </a>
      ) : (
        <button
          id="SingleListingStickyActions-Call"
          type="button"
          disabled
          className="flex h-14 flex-col items-center justify-center gap-1 text-black/40"
          aria-label="Call unavailable"
        >
          <Phone size={16} />
          <span className="text-[11px] font-semibold uppercase tracking-[0.06em]">Call</span>
        </button>
      )}

      {hasDirections ? (
        <a
          id="SingleListingStickyActions-Directions"
          href={directionsHref}
          target="_blank"
          rel="noreferrer"
          className="flex h-14 flex-col items-center justify-center gap-1 text-black"
          aria-label="Directions"
          title={`listing field: ${directionsField}`}
        >
          <MapPin size={16} />
          <span className="text-[11px] font-semibold uppercase tracking-[0.06em]">Directions</span>
        </a>
      ) : (
        <button
          id="SingleListingStickyActions-Directions"
          type="button"
          disabled
          className="flex h-14 flex-col items-center justify-center gap-1 text-black/40"
          aria-label="Directions unavailable"
        >
          <MapPin size={16} />
          <span className="text-[11px] font-semibold uppercase tracking-[0.06em]">Directions</span>
        </button>
      )}

      <button
        id="SingleListingStickyActions-Deals"
        type="button"
        onClick={() => navigate('/offers')}
        disabled={navigationLocked}
        className={`flex h-14 flex-col items-center justify-center gap-1 ${navigationLocked ? 'text-black/40' : 'text-black'}`}
        aria-label="Deals"
      >
        <Gift size={16} />
        <span className="text-[11px] font-semibold uppercase tracking-[0.06em]">Deals</span>
      </button>

      <button
        id="SingleListingStickyActions-More"
        type="button"
        onClick={onMore}
        className="flex h-14 flex-col items-center justify-center gap-1 text-black"
        aria-label="More"
      >
        <Ellipsis size={16} />
        <span className="text-[11px] font-semibold uppercase tracking-[0.06em]">More</span>
      </button>
    </nav>
  );
}

export default SingleListingSticky;
